<template>
  <div>
    <table-local-v-1-widget
      :items="items"
      :columns="columns"
      :actions="actions"
      :loading="loading"
      @clickView="row => $emit('clickView', row)"
    />
    <!-- <pre>{{ items }}</pre> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [],
      columns: [
        {
          label: 'วันที่ (วัน-เดือน-ปี)',
          field: 'created_at',
          formatFn: val => this.$date(val).format('DD-MM-YYYY HH:mm'),
          tdClass: 'text-center',
          thClass: 'text-center',
        },
        {
          label: 'ร้าน',
          field: 'user_as_shop_name',
          tdClass: 'text-center',
          thClass: 'text-center',
        },
        // {
        //   label: 'อีเมล',
        //   field: 'email',
        //   tdClass: 'text-center',
        //   thClass: 'text-center',
        // },
        {
          label: 'ยอดสุทธิ',
          field: 'transaction_data_as_withdraw_amount',
          type: 'currency',
          tdClass: 'text-center text-success',
          thClass: 'text-center',
        },

        {
          label: 'สาเหตุที่ไม่อนุมัติ',
          field: 'transaction_data_as_note',
          thClass: 'text-center text-danger',
          tdClass: 'text-center',
        },
      ],
      loading: false,
      actions: [{ keyEmit: 'clickView', iconName: 'EyeIcon', label: 'ดูเพิ่มเติม' }],
    }
  },
  created() {
    this.getWithdrawReject()
  },
  methods: {
    async getWithdrawReject() {
      this.loading = true
      const resp = await this.api.get('api/admin/partner-withdraw/index?filter=reject').catch(() => {})
      // console.log('getWithdrawReject', resp)
      if (resp) {
        this.items = [...resp]
      }

      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped></style>
